export const settings = {
    baseServingSize: 8,
    servingSizes: [8, 16],
    filterId: 'tomato-sauce',
    filterLabel: 'Make tomato sauce from scratch',
    filterInitialState: true
}